module.exports = __webpack_public_path__ + "img/26_197.42467fc1.png";